/**
 * ID Encryption Plugin
 * Makes encrypt/decrypt functions available globally via $encryptUUID and $decryptUUID
 */

import { encryptUUID, decryptUUID } from '~/utils/idEncryption'

export default ({ app }, inject) => {
  // Inject encryptUUID function globally
  inject('encryptUUID', encryptUUID)

  // Inject decryptUUID function globally
  inject('decryptUUID', decryptUUID)
}
